// src/context/AuthContext.js
import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  loginUser,
  setAuthToken,
  setRefreshToken,
  clearAuthToken,
  getAuthToken,
} from "../Services/APIService";
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  // Load user from stored token
  const [user, setUser] = useState(() => {
    const token = getAuthToken();
    if (!token) return null;

    try {
      const decoded = jwtDecode(token);

      // If token is expired
      if (decoded.exp * 1000 < Date.now()) {
        clearAuthToken();
        return null;
      }

      return {
        email: decoded.email,
        role: decoded.role,
        id: decoded.UserId,
        publisherId: decoded.PublisherId || null,
        exp: decoded.exp,
      };
    } catch {
      clearAuthToken();
      return null;
    }
  });

  // Auto logout when token expires
  useEffect(() => {
    if (!user) return;

    const timeout = user.exp * 1000 - Date.now();
    console.log(`Auto logout in ${Math.round(timeout / 1000)} seconds`);

    const timer = setTimeout(() => {
      logout();
      alert("Session expired. Please log in again.");
    }, timeout);

    return () => clearTimeout(timer);
  }, [user]);


  const login = async (email, password) => {
    try {
      debugger
      const response = await loginUser(email, password);
      if (response === "") {
        toast.error("Login Failed!");
        return;
      }
      if (response.success === false) {
        toast.success(response.message);
        return;
      }
      setAuthToken(response.accessToken);
      setRefreshToken(response.refreshToken);

      const decoded = jwtDecode(response.accessToken);

      setUser({
        email: decoded.email,
        role: decoded.role,
        id: decoded.UserId,
        publisherId: decoded.PublisherId || null,
        exp: decoded.exp,
      });

      toast.success("Login successful!");
      setTimeout(() => navigate("/"), 1000);
      return true;
    } catch (err) {
      console.log("Login error response:", err.response); // 👈 Check what comes back
      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data ||
        err?.message ||
        "Login failed";
      toast.error(errorMessage);
      throw errorMessage;
    }
  };


  // Logout method
  const logout = () => {
    setUser(null);
    clearAuthToken();
    navigate("/login");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
